/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.12",
    versionName: "0.2.0-nightly.2025.11.12",
    versionChannel: "nightly",
    buildDate: "2025-11-12T00:09:16.138Z",
    commitHash: "0eb4a9233b73c3f45341c89b08bf61b6886a9a8f",
};
